import React from 'react';
import { InfoContainer } from '@lmn/design-system';
import { IconCircleInfoSolid } from '@/app/common/icons/libraryIcons';
import { css } from 'styled-components';
import { useTranslation } from '../translations/Translation';
import customCss from './css/customCss';

export function SoldOutMessage() {
  const { t } = useTranslation();

  return (
    <InfoContainer
      type="warning"
      icon={IconCircleInfoSolid}
      hasBorder={true}
      message={t('vacation.select.soldout.banner')}
      css={css`
        margin: 16px 16px 0;

        @media ${customCss.breakpoints.sm} {
          margin: 16px 24px 0;
        }

        @media ${customCss.breakpoints.lgPlus} {
          margin: 16px 40px 0;
        }

        @media ${customCss.breakpoints.xl} {
          margin: 16px 0 0 0;
        }
      `}
    />
  );
}
